import React from 'react'
import Appointment from '../TabProfile/Appointment'

export const Appointmentpage = () => {
  return (
    <>
    <Appointment/>
    </>
  )
}
